import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingPopupMinimizedHeaderActionsComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-minimized-header-actions/floating-popup-minimized-header-actions.component';
import { FloatingPopupBaseContentComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-base-content/floating-popup-base-content.component';
import { FLOATING_POPUP_DATA } from '@app/main/main-content/floating-popup-manager/providers/floating-popup-data.token';
import { FloatingPopupTabsService } from '@app/main/main-content/floating-popup-manager/services/floating-popup-tabs.service';
import { FpLoggerNoiseManagerStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/services/fp-logger-noise-manager/fp-logger-noise-manager.store';
import { toSignal } from '@angular/core/rxjs-interop';
import { FpLoggerNoiseManagerActionType } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/services/fp-logger-noise-manager/fp-logger-noise-manager.actions';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';
import { FloatingPopupBaseErrorMessageComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-base-error-message/floating-popup-base-error-message.component';

@Component({
  selector: 'gc-fp-logger-noise-minimized-content',
  standalone: true,
  imports: [
    CommonModule,
    FloatingPopupMinimizedHeaderActionsComponent,
    SpinnerComponent,
    FloatingPopupBaseErrorMessageComponent,
  ],
  templateUrl: './fp-logger-noise-minimized-content.component.html',
  styleUrls: ['./fp-logger-noise-minimized-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FpLoggerNoiseMinimizedContentComponent extends FloatingPopupBaseContentComponent {
  public readonly data = inject<ILdLogger>(FLOATING_POPUP_DATA);
  private readonly floatingPopupTabs = inject(FloatingPopupTabsService);
  private readonly floatingPopupManagerStore = inject(FpLoggerNoiseManagerStore);

  public activeTabConnectService = toSignal(this.floatingPopupManagerStore.activeTabConnectService$, {
    initialValue: null,
  });

  public selectedTab = computed(() => this.floatingPopupTabs.getActive(this.popupId())());

  public loading = toSignal(this.floatingPopupManagerStore.loading$, {
    initialValue: false,
  });

  public activeTabLoading = toSignal(this.floatingPopupManagerStore.activeTabLoading$, {
    initialValue: false,
  });

  public selectedData = toSignal(this.floatingPopupManagerStore.selectedData$, {
    initialValue: null,
  });

  public initialized = toSignal(this.floatingPopupManagerStore.initialized$, {
    initialValue: false,
  });

  constructor() {
    super();

    const effectRef = effect(() => {
      const popupId = this.popupId();

      if (popupId) {
        this.initPopupStoreManager(popupId);

        effectRef.destroy();
      }
    });
  }

  private initPopupStoreManager(popupId: string) {
    this.floatingPopupManagerStore.dispatch({
      type: FpLoggerNoiseManagerActionType.Init,
      popupId: popupId,
      selectedData: this.data,
      activeTab: this.floatingPopupTabs.getActive(popupId)() as FpLoggerNoiseTabs,
    });
  }
}
